import { render, staticRenderFns } from "./HighchartTopDefects.vue?vue&type=template&id=fa83e724&scoped=true&"
import script from "./HighchartTopDefects.vue?vue&type=script&lang=js&"
export * from "./HighchartTopDefects.vue?vue&type=script&lang=js&"
import style0 from "./HighchartTopDefects.vue?vue&type=style&index=0&id=fa83e724&scoped=true&lang=css&"
import style1 from "./HighchartTopDefects.vue?vue&type=style&index=1&id=fa83e724&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa83e724",
  null
  
)

export default component.exports